import { Outlet } from "react-router-dom";

export default function FinkAnalytics(props: any) {
  return (
    <div className="FinkAnalytics">
      <Outlet />
    </div>
  );
}
